export const lazyLoadMedia = () => {
    const media = document.querySelectorAll('[data-lazy-src]') as NodeListOf<HTMLImageElement | HTMLVideoElement>;

    if (media.length === 0) return;

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const el = entry.target as HTMLElement;

                if (el.tagName === 'IMG') {
                    const img = el as HTMLImageElement;
                    const dataSrc = img.getAttribute('data-lazy-src');
                    if (dataSrc) {
                        img.src = dataSrc;
                        img.removeAttribute('data-lazy-src');
                    }
                }

                if (el.tagName === 'VIDEO') {
                    const video = el as HTMLVideoElement;
                    const dataSrc = video.getAttribute('data-lazy-src');

                    // Set src on <video> directly if data-lazy-src exists
                    if (dataSrc) {
                        video.src = dataSrc;
                    }

                    // Or, if using <source> tags with data-lazy-src
                    const sources = video.querySelectorAll<HTMLSourceElement>('source[data-lazy-src]');
                    sources.forEach(source => {
                        const src = source.getAttribute('data-lazy-src');
                        if (src) {
                            source.src = src;
                            source.removeAttribute('data-lazy-src');
                        }
                    });

                    video.load();
                    video.removeAttribute('data-lazy-src');
                }

                obs.unobserve(el); // Stop observing once loaded
            }
        });
    })

    media.forEach(el => observer.observe(el));
}